import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';
import { farmMapping } from '@/utils/farms';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';

export default function HistoricTabs({ address }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_staked');

  const displayOptions = useMemo(() => {
    const rewardsValue =
      farmMapping(address) === 'chronicle_farm' ? 'Points' : 'Rewards';

    const options = [
      { key: 'total_staked', value: 'TVL' },
      { key: 'total_farmed', value: rewardsValue }
    ];

    if (farmMapping(address) !== 'chronicle_farm') {
      options.push({ key: 'apy', value: 'APY' });
    }

    if (farmMapping(address) === 'sky_farm') {
      options.push({ key: 'boosted_rewards', value: 'Boosted Rewards' });
    }

    return options;
  }, [address]);

  const [data, error] = useApi({
    url: `/farms/${address}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  let content;
  if (data) {
    content = (
      <HistoricGraphs
        data={data}
        timeFilter={timeFilter}
        address={address}
        chartDaysAgo={chartDaysAgo}
        activeDisplayOption={activeDisplayOption}
      />
    );
  } else {
    content = <ChartSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {content}
    </Flex>
  );
}
